import api from '@pray/shared/utils/api';

export type MinistryAccountSummary = {
  artist_id: string;
  artist_name: string;
  profile_image_url: string | null;
  contract_value_cents: number;
  total_budget_cents: number;
  lifetime_spend_cents: number;
  projected_revenue_cents: number;
  email_leads_count: number;
  followers_count: number;
  active_campaign_count: number;
};

export type GetMinistryAccountsParams = {
  artistId: string;
};

export const getMinistryAccounts = async ({ artistId }: GetMinistryAccountsParams) => {
  const url = `/web/studio/artists/${artistId}/dashboard/accounts`;
  const response = await api.executeGetRequest<{ data?: { data?: { accounts?: MinistryAccountSummary[] } } }>(url);
  return (response.data?.data?.data?.accounts ?? []) as MinistryAccountSummary[];
};
